import { AfterViewInit, Component, OnInit, AfterViewChecked, AfterContentInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-forum',
  templateUrl: './forum.component.html',
  styleUrls: ['./forum.component.css']
})
export class ForumComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  topics = [];
  no_user_account = false;
  isLoading = false;


  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }


  ngOnInit(): void {
    this.fetchForumTopics();
  }

  fetchForumTopics(){
    this.http.get(environment.FORUM_TOPICS,this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200){
          console.log(res.message)
          this.topics = res.message['topics'];
          console.log(this.topics);
        }  
        else{
          this.no_user_account = true;
          document.getElementById('no_user').click();
         
        }

      }, (err: any) => {
    
        console.log("Error while login :: ", err);
      })
  }

  routeToTopic(topicData){
    var id = topicData.id;
    var title = topicData.unicode_title ? topicData.unicode_title : topicData.title;
    var obj = {
      last_read_post_number: topicData.last_read_post_number,
      title: title
    }
    localStorage.setItem('topic', JSON.stringify(obj));

    this.router.navigate([`/${this.businessID}/forum/topic/${id}`]);
  }

  startForum(){
    var elm = (<HTMLInputElement>document.getElementById('userName')).value;

    console.log(elm);
    var req = {
      userName: elm
    }

    if(req.userName == '' || req.userName.length < 4){
      alert('Käyttäjänimesi pitää sisältää vähintään 4 merkkiä');
      return;
    }
    this.isLoading = true;
    this.http.post(environment.FORUM_EMPLOYER_REGISTER, req,this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200){
          console.log(res.message)
          this.no_user_account = false;
          document.getElementById('close_modal').click();
          this.fetchForumTopics();
        }  
        else{
          this.no_user_account = true;
          document.getElementById('no_user').click();
         
        }

      }, (err: any) => {
    
        console.log("Error while login :: ", err);
      })
  }



}
